import React, { useState } from 'react'
import classNames from 'classnames'
import { UserAgentConsumer } from '#src/containers/UserAgent'
import { SMSIconBox, LinkIconBox, EmailIconBox, FacebookIconBox } from '../ShareIcons'
import FacebookShare from '#src/components/Share/FacebookShare'
import EmailCollectionModal from '#src/components/Share/EmailCollectionModal'
import ShortLinkModal from '#src/components/Share/ShortLinkModal'
import SmsModal from '#src/components/Share/SmsModal'
import { isMobileBrowser } from '#src/services/mobile'
import styles from './styles.css'
import { createSellableShareUrl } from '#src/services/referrals'

enum Modal {
  Email,
  Link,
  Sms
}

export type ShareVariant = 'small' | 'large' | 'responsive'

interface Props {
  variant: ShareVariant
  sellableId: string
  sellableTitle: string
  departmentSlug: string
  className?: string
  referrerId: string
  entryPoint: Tracking.EntryPoint
  expertId?: string
}

const ShareSellableFooter: React.SFC<Props> = ({
  sellableId,
  sellableTitle,
  departmentSlug,
  referrerId,
  entryPoint,
  variant,
  className,
  expertId
}) => {
  const { linkShareUrl, fbShareUrl } = createSellableShareUrl({
    sellableTitle,
    sellableId,
    departmentSlug,
    referrerId,
    entryPoint
  })

  const [modal, setModal] = useState<null | Modal>(null)

  return (
    <div>
      <div className={classNames(styles.shareContainer, className)}>
        <LinkIconBox
          variant={variant}
          onClick={() => {
            setModal(Modal.Link)
          }}
        />

        <UserAgentConsumer>
          {ua =>
            // the sms prefill link does not work in our native WKWebView
            isMobileBrowser(ua) && (
              <SMSIconBox
                variant={variant}
                onClick={() => {
                  setModal(Modal.Sms)
                }}
              />
            )
          }
        </UserAgentConsumer>

        {expertId && (
          <EmailIconBox
            variant={variant}
            onClick={() => {
              setModal(Modal.Email)
            }}
          />
        )}

        <FacebookShare shareUrl={fbShareUrl}>
          {shareOnFacebook => (
            <FacebookIconBox
              variant={variant}
              onClick={() => {
                shareOnFacebook()
              }}
            />
          )}
        </FacebookShare>
      </div>

      {modal === Modal.Sms ? (
        <SmsModal onRequestClose={() => setModal(null)} smsShortenedUrl={linkShareUrl} />
      ) : modal === Modal.Link ? (
        <ShortLinkModal onRequestClose={() => setModal(null)} linkShareUrl={linkShareUrl} />
      ) : modal === Modal.Email && expertId ? (
        <EmailCollectionModal onRequestClose={() => setModal(null)} expertId={expertId} />
      ) : null}
    </div>
  )
}

export default ShareSellableFooter
